import { NgModule } from '@angular/core';
import { FileDropDirective } from './file-drop.directive';
import { UppercaseDirective } from './uppercase.directive';

@NgModule({
  imports: [],
  declarations: [FileDropDirective, UppercaseDirective],
  exports: [FileDropDirective, UppercaseDirective]
})
export class DirectivesModule { }
